module.exports = __webpack_public_path__ + "d00c532bcb2a65e4eba3cfcc10befe65.svg";